// @ts-nocheck

import * as Sentry from '@sentry/react';
import FontFaceObserver from 'fontfaceobserver';
import { useState, useEffect } from 'react';

import { __ } from '../../../i18n/l10n';

const useIsFontLoaded = (fonts, shouldRetry) => {
  const [isFontLoaded, setIsFontLoaded] = useState(false);
  const [isFontLoadedError, setIsFontLoadedError] = useState(false);

  useEffect(() => {
    let didCancel = false;

    const setIsFontLoadedSafe = (value) => {
      !didCancel && setIsFontLoaded(value);
    };

    (async () => {
      const observers = [];
      try {
        // Make one observer for each font by iterating over the data we already have
        Object.keys(fonts).forEach((font) => {
          const data = fonts[font];
          const fontObserver = new FontFaceObserver(font, data);
          observers.push(fontObserver.load(null, 30000)); // Second parameter is timeout in ms
        });

        await Promise.all(observers);
        setIsFontLoadedSafe(true);
      } catch (error) {
        console.warn('Some critical fonts are not available:', error);
        Sentry.captureMessage('unable to load fonts.', { extra: { font: Object.keys(fonts) } });
        setIsFontLoadedSafe(false);
        setIsFontLoadedError({
          errorType: __('An error has occured'),
          errorText: __('We were unable to generate your final image'),
        });
      }
    })();
    return () => (didCancel = true);
  }, [fonts, shouldRetry]);
  return {
    isFontLoaded,
    isFontLoadedError,
  };
};

export default useIsFontLoaded;
